<template>
  <div class="newsBox" :style="topbgc1">
    <div class="topnav">
      <div class="imgBox">
        <img :src="logo2" alt="">
      </div>
      <div class="navBox">
        <a :class="currentIndex==0?'nowNav':'Nav'" href="http://www.pengzushijia.com" target="_blank" @click="gonav(0)">门户首页</a>
        <a :class="currentIndex==1?'nowNav':'Nav'" href="http://maker.pengzushijia.com" target="_blank" @click="gonav(1)">编纂平台</a>
        <a :class="currentIndex==2?'nowNav':'Nav'" href="http://i.pengzushijia.com/database" target="_blank" @click="gonav(2)">总数据库</a>
<!--        <a :class="currentIndex==3?'nowNav':'Nav'" href="http://i.pengzushijia.com/rootsearch" target="_blank" @click="gonav(3)">根籍搜索</a>-->
        <!--<a :class="currentIndex==4?'nowNav':'Nav'" href="http://admin.pengzushijia.com" target="_blank" @click="gonav(4)">管理平台</a>-->
        <a :class="currentIndex==5?'nowNav':'Nav'" href="javascript:void(0);" @click="gonav(5)">帮助中心</a>
      </div>
    </div>
    <div class="center">
      <div class="logobox">
        <img :src="logo1" alt="">
      </div>
      <p>根籍搜索</p>
      <div class="searchbox">
        <span>全部</span><input v-model="keys" type="text" class="keys_input" placeholder="输入关键字搜索《彭祖世家总谱·》"><div class="btn">
          一键搜索
        </div>
      </div>
    </div>
    <!--<houtailogin v-show="currentIndex==4" class="center2" />-->
    <div class="foot">
      <span>©2019彭祖世家网·《彭祖世家总谱·事典》总谱官网及门户网站  Pengzushijia.COM 彭祖世家文化发展有限公司</span>
    </div>
    <!--<div v-show="currentIndex==4" class="foot2">-->
    <!--<span>©2019彭祖世家网·《彭祖世家总谱·事典》总谱官网及门户网站  Pengzushijia.COM 彭祖世家文化发展有限公司</span>-->
    <!--</div>-->
  </div>
</template>
<script>
import houtailogin from '@/views/components/houtailogin/index.vue'
export default {

  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '根籍搜索-',
      mateDesc: metaStr
    }
  },
  components: { houtailogin },
  data() {
    return {
      currentIndex: 3,
      keys: '',
      logo2: require('@/static/logo_gengji2.png'),
      logo1: require('@/static/search_logo_peng.png'),
      topbgc1: {
        backgroundImage: 'url(' + require('@/static/gengji_banner.png') + ')'
      }
    }
  },
  created() {

  },
  mounted() {
    this.$emit('footshow', 8)
  },
  methods: {
    gonav(index) {
      this.currentIndex = index
      if (index === 4) {
        this.topbgc1.backgroundImage = 'url(' + require('@/static/peng_login_admin.png') + ')'
      } else {
        this.topbgc1.backgroundImage = 'url(' + require('@/static/gengji_banner.png') + ')'
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .newsBox{
      position: relative;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      min-height: 100vh;
      overflow: hidden;
      .topnav{
        overflow: hidden;
        padding-left: 60px;
        padding-top: 38px;
        padding-right: 40px;
        .imgBox{
          width: 203px;
          height: 52px;
          font-size: 0;
          display: inline-block;
          img{
            width: 203px;
            height: 52px;
          }
        }
        .navBox{
          float: right;
          padding: 16px 0;
          a{
            display: inline-block;
            height: 20px;
            width: 78px;
            padding-bottom: 8px;
            text-align: center;
            color: #a98450;
            font-size: 15px;
            cursor: pointer;
            &:hover{
              color: #ed4040;
            }
          }
          .nowNav{
            border-bottom: 2px solid #7e6a5a;
            color: #7e6a5a;
          }
        }
      }
      .center{
        margin-top: 180px;
        overflow: hidden;
        text-align: center;
        .logobox{
          width: 506px;
          height: 70px;
          font-size: 0;
          display: inline-block;
          img{
            width: 506px;
            height: 70px;
          }
        }
        p{
          margin-top: 30px;
          font-size: 44px;
          font-family:  KaiTi,SimSun;
        }
        .searchbox{
          overflow: hidden;
          margin-top: 40px;
          span{
            display: inline-block;
            height: 38px;
            width: 98px;
            border: 1px solid #7e6b5a;
            vertical-align: top;
            text-align: center;
            line-height: 40px;
          }
          .keys_input{
            height: 38px;
            width: 313px;
            border-top: 1px solid #7e6b5a;
            border-bottom: 1px solid #7e6b5a;
            padding-left:5px;
            vertical-align: top;
          }
          .btn{
            display: inline-block;
            background-color: #7e6b5a;
            color: #ffffff;
            line-height: 40px;
            height: 40px;
            text-align: center;
            width: 101px;
            cursor: pointer;
          }
        }
      }
      .foot{
        position: absolute;
        bottom: 0;
        height: 60px;
        background-color: rgba(184,179,172,.6);
        width: 100%;
        line-height: 60px;
        text-align: center;
        span{
          font-size: 12px;
        }
      }
      .foot2{
        margin-top: 50px;
        bottom: 0;
        height: 60px;
        width: 100%;
        line-height: 60px;
        text-align: center;
        font-size: 12px;
        color: #c5c1be;
      }
    }
  .center2{
    overflow: hidden;
    margin-top: 50px;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .newsBox .center{
      margin-top: 60px;
      .logobox{
        display: none;
      }
      .searchbox {
        .keys_input{
          width: calc( 100vw - 169px );
          background: #fff;
        }
        span{
          width: 65px;
          background: #fff;
        }
        .btn{
          width: 80px;
        }
      }
    }
  }
</style>
